import { createEffect, lazy, Show } from "solid-js";
import { FileRoutes } from "@solidjs/start/router";

import Env from "@repo/utils-client/Env";
import USolid from "@repo/utils-solid/USolid";

import SharedRootRouter from "~shared/SharedRootRouter";

import { useAdmin } from "./state/features/admin";
import { useFeatureFlags } from "./state/features/featureFlags";
import { useUser } from "./state/features/user";
import { useOverlaysBase } from "./overlays";

const AdminPanel = lazy(() => import("./components/admin/AdminPanel"));

export default function App() {
  return (
    <SharedRootRouter
      root={(props) => {
        const overlaysBase = useOverlaysBase();

        const [featureFlags] = useFeatureFlags();
        const [user, setUser] = useUser();
        const [admin, setAdmin] = useAdmin();

        createEffect(() => {
          if (featureFlags.enabled("community") === false)
            window.location.replace(Env.resolveUrl(import.meta.env.WEB_ORIGIN));
          if (featureFlags.enabled("community"))
            setUser.dismiss("viewCommunity");
        });

        createEffect(() => {
          if (USolid.runMemo(() => !!user.pii()?.email.endsWith("@kikoff.com")))
            setAdmin.fetch();
        });

        return (
          <div>
            {props.children}
            {overlaysBase.render()}
            <Show when={admin()}>
              <AdminPanel />
            </Show>
          </div>
        );
      }}
    >
      <FileRoutes />
    </SharedRootRouter>
  );
}
